module.exports = __webpack_public_path__ + "static/media/nft-23.d956e41c.jpg";